import React from 'react';
import { Helmet } from 'react-helmet';

// Modern (jjfv2) header / hero / footer — same as the About Us & Blogs pages
import HeaderV2 from '../../components/headerV2/HeaderV2';
import FooterV2 from '../../components/footerV2/FooterV2';
import AboutHero from '../../components/aboutHero/AboutHero';

import BlogSidebar from './BlogSidebar';

// CSS imports
import '../AboutUsPage/aboutV2.css';
import './blogs.css';

// Image imports
import Blog1Img from "./../../images/blogs/humanity_blog.webp";

export default function HumanityBlogPage() {
    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap"
                    rel="stylesheet"
                />

                {/* Basic Meta Tags */}
                <title>Where Humanity Finds Its Purpose | JJF India</title>
                <meta name="description" content="Hero? No. I’m just doing what I should. Explore the heart of JJFIndia and our mission to make service a shared human responsibility." />
                <meta name="keywords" content="JJFIndia blood donation, LifeSaverArmy, Aadhar Blood Bank collaboration, Humanitarian service India, Blood donation drive 2025, Jainam Jivika Foundation" />
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://jjfindia.com/our-bulletin/where-humanity-finds-its-purpose" />

                {/* Open Graph */}
                <meta property="og:title" content="Where Humanity Finds Its Purpose | JJF India" />
                <meta property="og:description" content="Hero? No. I’m just doing what I should. Explore the heart of JJFIndia and our mission to make service a shared human responsibility." />
                <meta property="og:url" content="https://jjfindia.com/our-bulletin/where-humanity-finds-its-purpose" />

                {/* Twitter Cards */}
                <meta name="twitter:title" content="Where Humanity Finds Its Purpose | JJF India" />
                <meta name="twitter:description" content="Hero? No. I’m just doing what I should. Explore the heart of JJFIndia and our mission to make service a shared human responsibility." />
            </Helmet>

            {/* Modern header + hero band */}
            <div className="jjfv2">
                <HeaderV2 />
                <AboutHero
                    eyebrow="Our Bulletin"
                    title="Blogs"
                    crumbs={[{ label: 'Home', to: '/' }, { label: 'Blogs' }]}
                />
            </div>

            <main className="page_content">
                <div style={{ paddingBottom: "60px", paddingTop: "60px" }} className="container">
                    <div className='single-blog-container' >
                        <div className="blog-article">
                            <h1>Where Humanity Finds Its Purpose</h1>
                            <div>
                                <img src={Blog1Img} alt='blog' />
                            </div>
                            <div style={{ display: "flex", alignContent: "flex-end", width: "100%" }}>
                                <span style={{ width: "100%", textAlign: "right", paddingTop: "16px", paddingBottom: "16px" }}>10 November, 2023</span>
                            </div>
                            <div>
                                <p><q><strong>I asked him, do you really feel like a hero?</strong></q></p>
                                <p>He smiled and said softly, “Hero? No. I’m just doing what I should as a human being.”</p>
                                <p>That one simple line captures the heart of <strong>JJFIndia.</strong></p>
                                <p>We don’t see service as heroism. We see it as responsibility - a quiet promise we owe to one another as humans.</p>
                                <h2 className='single-blog-sub-heading' >Built on Compassion</h2>
                                <p>At <strong>JJFIndia (Jainam Jivika Foundation),</strong> compassion is not something extra - it’s at the centre of everything we do.</p>
                                <p>Every project, every volunteer, and every act of care begins with one belief: <strong>humanity must come first.</strong></p>
                                <p>Our work spans healthcare, education, environmental awareness, youth engagement and mental wellbeing -each action guided by empathy and purpose.</p>
                                <p>Among these, our <strong>LifeSaverArmy</strong> stands out for its simple but powerful goal: connecting those who can give blood with those who need it.</p>
                                <p>A Partnership That Saved Lives</p>
                                <p>Recently, <strong>JJFIndia joined hands with Aadhar Blood Bank</strong> for a blood donation drive that brought people together for a shared cause -saving lives.</p>
                                <p>By the end of the day, <strong>28 volunteers registered,</strong> and <strong>28 units of blood were successfully connected</strong> to patients in need.</p>
                                <p>Each unit tells a story - of relief, recovery, and renewed hope.</p>
                                <p>Behind every donation is someone who decided to act instead of looking away, proving that kindness still holds quiet power in our world.</p>
                                <h2 className='single-blog-sub-heading' >Service Without Showmanship</h2>
                                <p>At <strong>JJFIndia,</strong> we believe the most meaningful work often happens away from the spotlight.</p>
                                <p>We don’t count followers; we count lives touched.</p>
                                <p>Each volunteer, donor and coordinator forms part of a caring chain that reaches across cities and hearts.</p>
                                <p>Their reward isn’t recognition -it’s the knowledge that someone, somewhere, is breathing easier because they cared enough to help.</p>
                                <h2 className='single-blog-sub-heading' >Together, We Give Life</h2>
                                <p>The success of the Aadhar Blood Bank collaboration is more than a number- it’s a reminder of what’s possible when people care.</p>
                                <p><strong>JJFIndia</strong> continues to build connections that bring hope, health and dignity to those who need it most.</p>
                                <p>Because for us, helping others isn’t an act of charity -it’s who we are.</p>
                                <p><strong>JJFIndia. Together, we give life.</strong></p>
                            </div>
                        </div>
                        <div>
                            <BlogSidebar />
                        </div>
                    </div>
                </div>
            </main>

            {/* Modern footer */}
            <div className="jjfv2">
                <FooterV2 />
            </div>
        </>
    );
}
